import React from "react";

export function TrendsSkeleton() {
  return (
    <div className="flex-1 bg-white shadow rounded p-12 mt-4 animate-pulse">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-7 h-7 bg-gray-200 rounded-full" />
        <div className="h-6 w-40 bg-gray-200 rounded" />
      </div>

      <div className="flex justify-between items-center w-full">
        {/* PARTICIPATION */}
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gray-200 rounded-full" />
            <div className="w-16 h-10 bg-gray-200 rounded" />
          </div>
          <div className="w-32 h-4 bg-gray-200 rounded mt-2" />
          <div className="w-64 h-4 bg-gray-200 rounded-full mt-3" />
        </div>

        {/* WELLNESS PRACTICES */}
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gray-200 rounded-full" />
            <div className="w-24 h-10 bg-gray-200 rounded" />
          </div>
          <div className="w-32 h-4 bg-gray-200 rounded mt-2" />
        </div>

        {/* MOST INCREASED EMOTION */}
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gray-200 rounded-full" />
            <div className="w-10 h-6 bg-gray-200 rounded" />
          </div>
          <div className="w-32 h-4 bg-gray-200 rounded mt-2" />
        </div>

        {/* MOST DECREASED EMOTION */}
        <div className="flex flex-col items-center gap-2">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gray-200 rounded-full" />
            <div className="w-10 h-6 bg-gray-200 rounded" />
          </div>
          <div className="w-32 h-4 bg-gray-200 rounded mt-2" />
        </div>
      </div>
    </div>
  );
}
